import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";
import { Partnership } from "../../service/api-response/PartnershipListSuccessResponse";

export const partnershipList = (
  state: RootState,
  org: OrganizationKeyName
): Partnership[] => {
  return state.partnership.partnershipsByOrg[org] || [];
};

export const isLoadingPartnershipList = (
  state: RootState,
  org: OrganizationKeyName
): boolean => {
  return state.partnership.isLoadingPartnershipsByOrg[org] || false;
};
